export default "__VITE_ASSET__5569c4c2__"